import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { SectionHeading } from './SectionHeading';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section aria-labelledby="testimonios" className="bg-mist" data-id="element-149" data-mp="3fym8yp543a6g">
      <div className="mx-auto max-w-3xl px-4 py-6 sm:px-6 sm:py-8" data-id="element-150" data-mp="3b0udjl59d5xi">
        <SectionHeading id="testimonios" title="Lo que dicen quienes ya empezaron" subtitle="De cero a comprender la lógica de los sistemas de seguridad electrónica." data-id="element-151" data-mp="3ayhz3hypldp7" />

        <ul className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-152" data-mp="3228za26tkd2j">
          {testimonials.map((t, i) => <Reveal key={t.author} as="li" delay={i * 0.03} className={`flex flex-col rounded-xl bg-white p-3.5 ${i === testimonials.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-153" data-mp="2x2mm1sqzqwtq" data-mpi={i}>
              <div className="flex gap-0.5" role="img" aria-label="5 de 5 estrellas" data-id="element-154" data-mp="qavddxugg15g">
                {Array.from({
              length: 5
            }).map((_, j) => <StarIcon key={j} size={13} className="fill-gold text-gold" aria-hidden="true" data-id="element-155" data-mp="m4rowevdji7h" data-mpi={j} />)}
              </div>
              <blockquote className="mt-1.5 text-[0.82rem] leading-snug text-graphite sm:text-sm" data-id="element-156" data-mp="c7mwhxaxqqi8">
                “{t.quote}”
              </blockquote>
              <div className="mt-auto flex items-center gap-2.5 pt-2.5" data-id="element-157" data-mp="14vj0zo6qxmpk">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-navy font-display text-xs font-bold text-electric" aria-hidden="true" data-id="element-158" data-mp="14xlqm73zldtr">
                  {initials(t.author)}
                </span>
                <div className="leading-tight" data-id="element-159" data-mp="1itqshgl0jvtc">
                  <p className="font-display text-sm font-bold text-navy" data-id="element-160" data-mp="1nlqsta4zwqqg">{t.author}</p>
                  <p className="text-[0.7rem] text-graphite-muted" data-id="element-161" data-mp="1xi0ld4puflw0">
                    {t.role} · {t.location}
                  </p>
                </div>
              </div>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}
function initials(name: string) {
  return name.split(' ').map(part => part[0]).slice(0, 2).join('');
}